module.exports = __webpack_public_path__ + "static/media/MANUAL_INSTALACIÓN_TERNIU_MULTYPANEL.9f4427dc.pdf";